import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../auth.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService,private router: Router) { }

  ngOnInit() {
   // if(window.location.hash && window.location.hash.indexOf('#/') !== 0)
    this.authService.completeAuthentication()
    .then(
      t=>this.router.navigate(['/'])
    )
    .catch(c =>  console.error(c));
  }

}
